import React from 'react';
import { handleActions } from 'redux-actions';
import * as ActionTypes from '../../constants/ActionTypes';
import {
    availableFontSizes,
    availableFontStyle,
    availableTextDecoration,
    availableLineHeight,
    availableTextAlign,
    availableBorderStyle,
    availableBorderWidth
} from '../../constants/availableFonts';

const globalStoreDefaults = {
    availableFontSizes: availableFontSizes,
    availableFontStyle: availableFontStyle,
    availableTextDecoration: availableTextDecoration,
    availableLineHeight: availableLineHeight,
    availableTextAlign: availableTextAlign,
    availableBorderStyle: availableBorderStyle,
    availableBorderWidth: availableBorderWidth
};

const globalReducer = (state = globalStoreDefaults, action) => {
    return state;
};

export default globalReducer;



// WEBPACK FOOTER //
// ./src/reducers/theme/global.js